import styled from "styled-components"
import { DateRange } from "react-date-range"

import { StyledButton } from "../../components/button/button.component.styles"
import { SPACING } from "../../design/spacing/spacing.constants"
import { COLOR } from "../../design/color/color.constants"
import { DEFAULT_FONT_STACK } from "../../design/typography/typography.constants"

const CalendarWrapper = styled.div`
  position: absolute;
  z-index: 1;
  border: solid 1px ${COLOR.GREY_LIGHT};
  ${DEFAULT_FONT_STACK};
`

const StyledDateRange = styled(DateRange)`
  width: 587px;
`
const Footer = styled.div`
  border-top: solid 1px ${COLOR.GREY_LIGHT};
  width: 587px;
  background-color: white;
  text-align: right;
  padding: ${SPACING.S} ${SPACING.M} ${SPACING.S} 0;
  ${StyledButton} {
    margin-right: ${SPACING.S};
    :last-of-type {
      margin-right: 0;
    }
  }
`

export {
  StyledDateRange,
  CalendarWrapper,
  Footer
}
